export const GEO_URL = "https://cdn.jsdelivr.net/npm/world-atlas@2/countries-110m.json";

export const COUNTRIES = [
  {
    country: "India",
    countryCode: "IN",
    center: [78.9629, 20.5937],
    zoomCenter: [78.9629, 22.0],
    zoomLevel: 4,
    count: 2847,
    states: [
      { name: "Maharashtra", count: 856, offset: [-2.5, -1.5], spread: [1.1, 0.9] },
      { name: "Karnataka", count: 542, offset: [-3.2, -4.8], spread: [0.9, 0.8] },
      { name: "Delhi", count: 489, offset: [-1.0, 8.2], spread: [0.6, 0.5] },
      { name: "Tamil Nadu", count: 412, offset: [-2.8, -8.2], spread: [0.8, 0.7] },
      { name: "Telangana", count: 325, offset: [-1.8, -3.2], spread: [0.8, 0.7] },
      { name: "Gujarat", count: 223, offset: [-7.5, 0.5], spread: [0.9, 0.8] },
      { name: "West Bengal", count: 180, offset: [5.5, 2.5], spread: [0.7, 0.8] },
    ],
  },
  {
    country: "Canada",
    countryCode: "CA",
    center: [-96.7969, 56.1304],
    zoomCenter: [-96.7969, 56.0],
    zoomLevel: 3,
    count: 1523,
    states: [
      { name: "Ontario", count: 612, offset: [9.5, -5.5], spread: [1.8, 1.4] },
      { name: "British Columbia", count: 428, offset: [-21.0, -3.5], spread: [1.4, 1.2] },
      { name: "Quebec", count: 285, offset: [18.5, -3.0], spread: [1.6, 1.5] },
      { name: "Alberta", count: 198, offset: [-13.5, -4.5], spread: [1.3, 1.1] },
    ],
  },
  {
    country: "USA",
    countryCode: "US",
    center: [-99.9018, 38.4925],
    zoomCenter: [-99.9018, 39.0],
    zoomLevel: 3,
    count: 1124,
    states: [
      { name: "California", count: 342, offset: [-18.5, -1.5], spread: [1.2, 1.5] },
      { name: "Texas", count: 287, offset: [-6.0, -8.5], spread: [1.5, 1.3] },
      { name: "New York", count: 245, offset: [13.5, 4.5], spread: [0.7, 0.6] },
      { name: "Florida", count: 158, offset: [8.5, -9.5], spread: [0.8, 0.7] },
      { name: "Washington", count: 92, offset: [-19.5, 5.5], spread: [0.9, 0.7] },
    ],
  },
  {
    country: "UK",
    countryCode: "GB",
    center: [-2.2, 54.0],
    zoomCenter: [-2.2, 54.5],
    zoomLevel: 6,
    count: 324,
    states: [
      { name: "England", count: 245, offset: [0.0, -3.0], spread: [0.6, 0.7] },
      { name: "Scotland", count: 52, offset: [0.5, 3.5], spread: [0.5, 0.6] },
      { name: "Wales", count: 27, offset: [-2.5, -2.0], spread: [0.4, 0.4] },
    ],
  },
  {
    country: "Germany",
    countryCode: "DE",
    center: [10.4515, 51.1657],
    zoomCenter: [10.4515, 51.5],
    zoomLevel: 6,
    count: 287,
    states: [
      { name: "Bavaria", count: 98, offset: [1.5, -2.5], spread: [0.7, 0.6] },
      { name: "Berlin", count: 87, offset: [2.5, 1.5], spread: [0.3, 0.3] },
      { name: "Hamburg", count: 62, offset: [-1.0, 3.5], spread: [0.3, 0.3] },
      { name: "NRW", count: 40, offset: [-3.0, 0.5], spread: [0.5, 0.4] },
    ],
  },
  {
    country: "Japan",
    countryCode: "JP",
    center: [138.2529, 36.2048],
    zoomCenter: [138.2529, 36.5],
    zoomLevel: 5,
    count: 256,
    states: [
      { name: "Tokyo", count: 112, offset: [2.5, 0.5], spread: [0.4, 0.4] },
      { name: "Osaka", count: 78, offset: [0.0, -3.5], spread: [0.4, 0.4] },
      { name: "Nagoya", count: 66, offset: [-0.5, -2.0], spread: [0.4, 0.4] },
    ],
  },
  {
    country: "Australia",
    countryCode: "AU",
    center: [133.7751, -25.2744],
    zoomCenter: [133.7751, -26.0],
    zoomLevel: 3,
    count: 198,
    states: [
      { name: "NSW", count: 84, offset: [9.5, -5.5], spread: [1.1, 1.0] },
      { name: "Victoria", count: 65, offset: [7.0, -9.5], spread: [0.9, 0.8] },
      { name: "Queensland", count: 49, offset: [11.0, 3.5], spread: [1.5, 1.8] },
    ],
  },
  {
    country: "Brazil",
    countryCode: "BR",
    center: [-51.9253, -12.235],
    zoomCenter: [-51.9253, -13.0],
    zoomLevel: 3,
    count: 167,
    states: [
      { name: "São Paulo", count: 78, offset: [4.0, -10.0], spread: [0.9, 0.8] },
      { name: "Rio de Janeiro", count: 52, offset: [7.5, -9.5], spread: [0.7, 0.6] },
      { name: "Brasília", count: 37, offset: [3.0, -3.5], spread: [0.5, 0.5] },
    ],
  },
  {
    country: "UAE",
    countryCode: "AE",
    center: [53.8478, 23.4241],
    zoomCenter: [53.8478, 24.5],
    zoomLevel: 7,
    count: 134,
    states: [
      { name: "Dubai", count: 72, offset: [2.5, -0.5], spread: [0.3, 0.2] },
      { name: "Abu Dhabi", count: 48, offset: [-2.5, -1.5], spread: [0.4, 0.3] },
      { name: "Sharjah", count: 14, offset: [3.5, 0.5], spread: [0.2, 0.2] },
    ],
  },
  {
    country: "Singapore",
    countryCode: "SG",
    center: [103.8198, 1.3521],
    zoomCenter: [103.8198, 1.5],
    zoomLevel: 10,
    count: 112,
    states: [
      { name: "Central", count: 58, offset: [0.0, 0.0], spread: [0.05, 0.04] },
      { name: "East", count: 32, offset: [0.15, 0.0], spread: [0.04, 0.03] },
      { name: "West", count: 22, offset: [-0.15, 0.0], spread: [0.04, 0.03] },
    ],
  },
  {
    country: "France",
    countryCode: "FR",
    center: [2.3522, 46.2276],
    zoomCenter: [2.3522, 46.5],
    zoomLevel: 6,
    count: 312,
    states: [
      { name: "Île-de-France", count: 148, offset: [0.5, 2.5], spread: [0.5, 0.4] },
      { name: "Auvergne-RA", count: 72, offset: [2.5, -1.5], spread: [0.7, 0.6] },
      { name: "Provence", count: 54, offset: [3.5, -4.5], spread: [0.6, 0.5] },
      { name: "Normandy", count: 38, offset: [-2.0, 4.5], spread: [0.6, 0.5] },
    ],
  },
  {
    country: "Netherlands",
    countryCode: "NL",
    center: [5.2913, 52.1326],
    zoomCenter: [5.2913, 52.3],
    zoomLevel: 8,
    count: 178,
    states: [
      { name: "Noord-Holland", count: 88, offset: [-0.5, 1.0], spread: [0.3, 0.3] },
      { name: "Zuid-Holland", count: 56, offset: [-0.8, -0.2], spread: [0.3, 0.3] },
      { name: "Utrecht", count: 34, offset: [0.4, 0.3], spread: [0.2, 0.2] },
    ],
  },
  {
    country: "Sweden",
    countryCode: "SE",
    center: [18.6435, 60.1282],
    zoomCenter: [18.6435, 60.5],
    zoomLevel: 5,
    count: 145,
    states: [
      { name: "Stockholm", count: 74, offset: [1.5, -2.5], spread: [0.5, 0.5] },
      { name: "Västra Götaland", count: 41, offset: [-1.0, -6.0], spread: [0.6, 0.5] },
      { name: "Skåne", count: 30, offset: [0.0, -8.0], spread: [0.5, 0.4] },
    ],
  },
  {
    country: "South Korea",
    countryCode: "KR",
    center: [127.7669, 35.9078],
    zoomCenter: [127.7669, 36.2],
    zoomLevel: 6,
    count: 198,
    states: [
      { name: "Seoul", count: 92, offset: [-0.5, 2.5], spread: [0.4, 0.3] },
      { name: "Busan", count: 54, offset: [2.0, -1.0], spread: [0.3, 0.3] },
      { name: "Incheon", count: 52, offset: [-1.5, 1.8], spread: [0.3, 0.3] },
    ],
  },
  {
    country: "Mexico",
    countryCode: "MX",
    center: [-102.5528, 23.6345],
    zoomCenter: [-102.5528, 24.0],
    zoomLevel: 4,
    count: 134,
    states: [
      { name: "CDMX", count: 58, offset: [3.5, -3.5], spread: [0.5, 0.4] },
      { name: "Jalisco", count: 42, offset: [-2.0, -1.5], spread: [0.7, 0.6] },
      { name: "Nuevo León", count: 34, offset: [3.5, 3.0], spread: [0.6, 0.5] },
    ],
  },
  {
    country: "Nigeria",
    countryCode: "NG",
    center: [8.6753, 9.0820],
    zoomCenter: [8.6753, 9.5],
    zoomLevel: 5,
    count: 156,
    states: [
      { name: "Lagos", count: 82, offset: [-3.5, -5.5], spread: [0.4, 0.3] },
      { name: "Abuja", count: 44, offset: [0.5, 0.0], spread: [0.4, 0.3] },
      { name: "Kano", count: 30, offset: [4.5, 7.5], spread: [0.5, 0.4] },
    ],
  },
  {
    country: "South Africa",
    countryCode: "ZA",
    center: [25.0833, -29.0],
    zoomCenter: [25.0833, -29.5],
    zoomLevel: 4,
    count: 112,
    states: [
      { name: "Gauteng", count: 56, offset: [3.5, 1.5], spread: [0.5, 0.4] },
      { name: "Western Cape", count: 34, offset: [-3.5, -7.0], spread: [0.6, 0.5] },
      { name: "KwaZulu-Natal", count: 22, offset: [7.5, -2.5], spread: [0.5, 0.5] },
    ],
  },
  {
    country: "Argentina",
    countryCode: "AR",
    center: [-63.6167, -38.4161],
    zoomCenter: [-63.6167, -36.0],
    zoomLevel: 3,
    count: 98,
    states: [
      { name: "Buenos Aires", count: 52, offset: [4.5, 7.5], spread: [1.0, 0.9] },
      { name: "Córdoba", count: 28, offset: [3.5, 6.5], spread: [0.7, 0.6] },
      { name: "Santa Fe", count: 18, offset: [5.0, 9.5], spread: [0.6, 0.6] },
    ],
  },
  {
    country: "Turkey",
    countryCode: "TR",
    center: [35.2433, 38.9637],
    zoomCenter: [35.2433, 39.5],
    zoomLevel: 5,
    count: 124,
    states: [
      { name: "Istanbul", count: 62, offset: [-7.5, 3.5], spread: [0.4, 0.3] },
      { name: "Ankara", count: 38, offset: [0.5, 1.5], spread: [0.4, 0.3] },
      { name: "Izmir", count: 24, offset: [-6.5, -0.5], spread: [0.3, 0.3] },
    ],
  },
  {
    country: "Indonesia",
    countryCode: "ID",
    center: [113.9213, -0.7893],
    zoomCenter: [113.9213, -1.0],
    zoomLevel: 4,
    count: 142,
    states: [
      { name: "Jakarta", count: 68, offset: [-8.5, -3.5], spread: [0.4, 0.4] },
      { name: "East Java", count: 42, offset: [-4.0, -3.8], spread: [0.7, 0.5] },
      { name: "Bali", count: 32, offset: [-2.5, -4.5], spread: [0.3, 0.3] },
    ],
  },
  {
    country: "Egypt",
    countryCode: "EG",
    center: [30.8025, 26.8206],
    zoomCenter: [30.8025, 27.5],
    zoomLevel: 5,
    count: 88,
    states: [
      { name: "Cairo", count: 48, offset: [1.5, 3.5], spread: [0.4, 0.3] },
      { name: "Alexandria", count: 26, offset: [-1.5, 5.8], spread: [0.3, 0.3] },
      { name: "Giza", count: 14, offset: [0.5, 3.0], spread: [0.3, 0.2] },
    ],
  },
  {
    country: "Spain",
    countryCode: "ES",
    center: [-3.7492, 40.4637],
    zoomCenter: [-3.7492, 40.8],
    zoomLevel: 6,
    count: 176,
    states: [
      { name: "Madrid", count: 86, offset: [0.5, 0.5], spread: [0.5, 0.4] },
      { name: "Catalonia", count: 54, offset: [5.5, 2.5], spread: [0.5, 0.5] },
      { name: "Andalusia", count: 36, offset: [0.0, -5.5], spread: [0.9, 0.7] },
    ],
  },
  {
    country: "Italy",
    countryCode: "IT",
    center: [12.5674, 41.8719],
    zoomCenter: [12.5674, 42.5],
    zoomLevel: 6,
    count: 162,
    states: [
      { name: "Lombardy", count: 74, offset: [0.0, 4.5], spread: [0.5, 0.4] },
      { name: "Lazio", count: 52, offset: [1.0, -0.5], spread: [0.4, 0.4] },
      { name: "Sicily", count: 36, offset: [1.5, -8.5], spread: [0.5, 0.4] },
    ],
  },
];

export function getGeoName(code) {
  const map = {
    IN: "India",
    CA: "Canada",
    US: "United States of America",
    GB: "United Kingdom",
    DE: "Germany",
    JP: "Japan",
    AU: "Australia",
    BR: "Brazil",
    AE: "United Arab Emirates",
    SG: "Singapore",
    FR: "France",
    NL: "Netherlands",
    SE: "Sweden",
    KR: "South Korea",
    MX: "Mexico",
    NG: "Nigeria",
    ZA: "South Africa",
    AR: "Argentina",
    TR: "Turkey",
    ID: "Indonesia",
    EG: "Egypt",
    ES: "Spain",
    IT: "Italy",
  };
  return map[code] ?? code;
}
